<!--微信支付-->
<template>
  <div class="payCheck-container">
    <headerIndex/>
    <div class="payCheck-content" :style="'min-height:'+min_height+'px'">
      <div class="top-check">
        <p>
          <span class="payCheck-status SourceHanSansCN">订单提交成功，请尽快付款！订单号：{{ orderInfo.orderNum }}</span>
          <span class="right-span">应付金额<span class="red-span">{{ orderInfo.total }}元</span></span>
        </p>
      </div>
      <div class="qr-code"  v-loading="disabled" element-loading-text="二维码已过期，请刷新页面重新获取二维码" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.65)">
        <p>
          <span class="small-title SourceHanSansCN">{{ orderInfo.payType }}</span>
          <span class="gray-span">距离二维码过期还剩{{ msg }}，过期后请刷新页面重新获取二维码。</span>
        </p>
        <div class="qr">
          <el-image style="height: 420px;width: 420px" class="qr-img" :src="qrCode"/>
        </div>
        <div class="tips" v-if="orderInfo.payType=='余额支付'">
          <p>请使用帮企网扫一扫</p>
          <p>扫描二维码支付</p>
        </div>
        <div class="tips" v-else>
          <p>请使用微信扫一扫</p>
          <p>扫描二维码支付</p>
        </div>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {getMyOrderDetails} from "@/api/orderApi";
import {wxPay,refund} from '@/api/cloudServiceApi'
export default {
  name: "payCheck",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      orderInfo: {},
      orderNo: '185303888112',
      msg: "30分0秒",
      maxtime: 30 * 60, //倒计时时间
      // maxtime: 30, //倒计时时间
      timer: null,
      qrCode: '',
      cid:0,
      disabled:false,
    }
  },
  methods: {
    /*倒计时*/
    countDown() {
      if (this.maxtime >= 0) {
        let minutes = Math.floor(this.maxtime / 60);
        let seconds = Math.floor(this.maxtime % 60);
        this.msg = minutes + "分" + seconds + "秒";
        --this.maxtime;
      } else {
        clearInterval(this.timer);
        this.disabled = true;
      }
    },
    /*获取订单数据*/
    getOrderInfo(){
      getMyOrderDetails({order_id: this.$route.query.id, uid: this.cid, request: 'form'}).then(res=>{
        if (res.code==200){
          this.orderInfo=res.content.sselectMyOrderDetailsVo;
        }
      })
    },
    /*获取支付二维码*/
    wxPayCode(){
      wxPay({
        is_pcOrder:true,
        money:JSON.parse(this.$route.query.price),
        recharge_order_no:this.$route.query.ordernum,
        request:'form'
      }).then(res=>{
        if (res.code==200){
          this.qrCode=res.code_url;
        }
      })
    },
    /*获取订单支付状态*/
    getOrderStatus(){
      refund({orderNo:this.$route.query.ordernum, request:'form'}).then(res=>{
        if (res.code==200){
          this.$message.success('支付成功！');
          this.$router.replace({
            path: '/payment/paySuccess',
            query: {id: this.$route.query.id, ordernum: this.$route.query.ordernum},
          })
          clearInterval(this.timer);
        }
      })
    }
  },
  mounted() {
    this.getOrderInfo();
    this.timer = setInterval(() => {
      this.countDown();
    }, 1000);
    this.timer = setInterval(() => {
      this.getOrderStatus();
    }, 5000);
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.wxPayCode();
  }
}
</script>
<style scoped>
.payCheck-container >>> .payCheck-content .el-loading-spinner i {
  color: #fff;
  font-size: 30px;
}
.payCheck-container >>> .payCheck-content .el-loading-spinner .el-loading-text {
  color: #ffffff;
  margin: 3px 0;
  font-size: 16px;
}
</style>
<style scoped lang="scss">
.payCheck-container {
  background: #ffffff;

  .payCheck-content {
    padding: 60px 18% 45px;

    .top-check {
      p {
        margin-block-start: 0em;
        cursor: context-menu;

        .payCheck-status {
          font-size: 16px;
          color: #333333;
        }

        .right-span {
          float: right;
          font-size: 14px;
          color: #333333;

        }
      }

      .red-span {
        color: #FE273B;
      }
    }

    .qr-code {
      padding: 25px 20px;
      box-shadow: 0px 0px 3px -1px #808080;

      p {
        margin-block-start: 0em;
        margin-block-end: 0px;
        cursor: context-menu;

        .small-title {
          font-size: 18px;
          color: #333333;
        }

        .gray-span {
          color: #999999;
          font-size: 14px;
          padding-left: 20px;
        }
      }

      .qr {
        padding: 40px 20px 20px;
        display: flex;
        justify-content: center;

        .qr-img {
          padding: 20px;
          border: 1px solid #DDDDDD;
        }
      }
      .tips{
        text-align: center;
        color: #FE273B;
        line-height: 23px;
        font-size: 16px;
      }
    }
  }
}
</style>